import { FooterComponent } from './layout/footer/footer.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { NavBarComponent } from './layout/nav-bar/nav-bar.component';
import { LoadingComponent } from './layout/loading/loading.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthService } from '@core/auth/auth.service';
import { InterceptorService } from '@core/auth/interceptor.service';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { UTCDatePipe } from './shared/pipes/utclocal.pipe';
import { MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/legacy-dialog';
import { NgxMaskModule } from 'ngx-mask';
import { CustomDateFormat1, CustomDateFormat2 } from './shared/directive/datepicker-moment-formats';
import { NgxPermissionsModule } from 'ngx-permissions';
import { UnAuthorizedComponent } from './pages/401/unauthorized.component';
import { SideBarComponent } from './layout/side-bar/side-bar.component';
import { CourseSearchComponent } from './modules/search/pages/course-search.component';
import { ComplianceModule } from './modules/compliance/compliance.module';
import { VersionComponent } from './pages/version/version.component';
import { HttpResponseInterceptor } from './core/auth/http.response.interceptor.service';
import { HttpErrorInterceptor } from './core/auth/error-handler.interceptor.service';
import { ThemeDirective } from './shared/directive/theme.directive';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProfileComponent,
    NavBarComponent,
    SideBarComponent,
    LoadingComponent,
    VersionComponent,
    UTCDatePipe, 
    CustomDateFormat1,
    UnAuthorizedComponent,
    CourseSearchComponent,    
    FooterComponent,
    ThemeDirective
  ],  
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDatepickerModule, MatMomentDateModule,
    NgxMaskModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    ComplianceModule
  ],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpResponseInterceptor,
      multi: true
    }, AuthService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
